import Axios from "axios";

const baseURL = "https://core.dev.legalremit.com";

export const axiosInstance = Axios.create({
  baseURL: baseURL,
  timeout: 20000,
});
